export default __webpack_public_path__ + "static/media/15.5177fb9c.jpg";